import { Component, OnInit,Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
@Component({
  selector: 'app-alert-popup',
  templateUrl: './alert-popup.component.html',
  styleUrls: ['./alert-popup.component.scss']
})
export class AlertPopupComponent implements OnInit {

  constructor(
    
    public dialogRef: MatDialogRef<AlertPopupComponent>,  @Inject(MAT_DIALOG_DATA) public data: any
  ) {  }

  ngOnInit() {

  }

  cancelClick(): void {
    this.dialogRef.close();
  }
}
